import React from 'react';

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, componentStack: '' };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        // eslint-disable-next-line no-console
        console.error('ErrorBoundary caught an error', error, info);
        this.setState({ componentStack: info?.componentStack || '' });
    }

    render() {
        const { hasError, error, componentStack } = this.state;
        const { children } = this.props;
        if (hasError) {
            return (
                <div style={{ padding: 16 }}>
                    <h2>Une erreur s'est produite</h2>
                    <pre style={{ whiteSpace: 'pre-wrap' }}>{String(error)}</pre>
                    {componentStack && (
                        <details style={{ whiteSpace: 'pre-wrap', marginTop: 8 }}>
                            <summary>Trace du composant</summary>
                            {componentStack}
                        </details>
                    )}
                    <p>Essayez d'actualiser la page. Si le problème persiste, utilisez /logout pour réinitialiser la session.</p>
                </div>
            );
        }
        return children;
    }
}
